import { Theme } from '@mui/material';

import { makeStyles } from '~/theme';

const drawerWidth = 560;
const actionBoxHeight = 92;

export const useStyles = makeStyles()((theme: Theme) => ({
  drawer: {
    '& .MuiDrawer-paper': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      top: 'auto',
      bottom: 0,
      height: 'calc(100% - 64px)', // header height
      width: drawerWidth + 'px',
      [theme.breakpoints.down('sm')]: {
        width: '85%',
        minWidth: 'auto',
      },
    },
  },
  title: {
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '36px',
    margin: '24px 0 20px 24px',
  },
  subTitle: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '20px',
    marginBottom: '24px',
  },
  formBox: {
    height: '100%',
    overflowY: 'auto',
    position: 'relative',
    paddingBottom: actionBoxHeight + 'px',
  },
  padding: {
    padding: '0 24px',
  },
  actionBox: {
    height: actionBoxHeight + 'px',
    width: drawerWidth + 'px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    borderTop: '1px solid rgba(255, 255, 255, 0.2)',
    padding: '24px',
    position: 'fixed',
    bottom: 0,
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    marginBottom: '24px',
    width: '100%',
  },
  formHeader: {
    width: '100%',
    height: '80px',
    position: 'absolute',
    top: '0',
    left: '0',
  },
  avatarBox: {
    position: 'relative',
    zIndex: 1,
    backgroundColor: theme.palette.background.default,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '30px 0 0 24px',
  },
  updateBtnBox: {
    marginBottom: '10px',
    alignSelf: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '25px',
    },
  },
  registerBtn: {
    margin: '0 0 24px 24px',
  },
}));
